import { render, staticRenderFns } from "./appletIndex.vue?vue&type=template&id=1bab7bb6&scoped=true"
import script from "./appletIndex.vue?vue&type=script&lang=js"
export * from "./appletIndex.vue?vue&type=script&lang=js"
import style0 from "./appletIndex.vue?vue&type=style&index=0&id=1bab7bb6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bab7bb6",
  null
  
)

export default component.exports